import classNames from 'styles/utils/classNames';
import CheckboxMark from './CheckboxMark';

interface Props {
  name: string;
  selected: boolean;
  onToggle: () => void;
}

/** A pickable neighborhood in the request form (Figma "Filter tab new" with a checkbox). */
export default function NeighborhoodOptionRow({ name, selected, onToggle }: Props) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={selected}
      className={classNames(
        'flex h-11 w-full items-center justify-between rounded-md border px-ds-md transition-colors',
        selected
          ? 'border-color-border-selected-lightmode bg-color-bg-lightmode-primary shadow-[0px_4px_10px_0px_rgba(0,0,0,0.16)] dark:border-color-border-selected-darkmode dark:bg-color-bg-darkmode-primary'
          : 'border-transparent bg-color-bg-lightmode-secondary dark:bg-color-bg-darkmode-secondary',
      )}
    >
      <span className="flex min-w-0 items-center gap-ds-xs">
        <img src="/images/find/cityscape.svg" alt="" className="h-5 w-5 shrink-0" />
        <span className="typography-product-button-label-small truncate text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {name}
        </span>
      </span>
      <CheckboxMark checked={selected} size="md" />
    </button>
  );
}
